module.exports = __webpack_public_path__ + "assets/img/组 167@2x.780e16be.png";